import { fetchSuggestedPolicyGroups, normalizePageForSuggestPolicy } from '@shared/utils/suggestPolicy';

/**
 * Shared suggested-policy flow: implement getPagesForSuggestedPolicy() and register SuggestedPolicyModal.
 */
export default {
  data() {
    return {
      isSuggestingPolicy: false,
      showSuggestedPolicyModal: false,
      suggestedPolicyGroups: [],
      allPoliciesForSuggestion: [],
    };
  },
  methods: {
    getPagesForSuggestedPolicy() {
      return [];
    },
    getSuggestedPolicyEmptyMessage() {
      return 'No pages available for suggested policy.';
    },
    async onSuggestPolicy() {
      this.isSuggestingPolicy = true;
      this.showSuggestedPolicyModal = false;
      this.suggestedPolicyGroups = [];
      this.allPoliciesForSuggestion = [];

      try {
        const rawPages = await Promise.resolve(this.getPagesForSuggestedPolicy());
        if (!rawPages || rawPages.length === 0) {
          this.$message.info(this.getSuggestedPolicyEmptyMessage());
          return;
        }

        const normalized = rawPages.map(normalizePageForSuggestPolicy).filter(p => p.id != null);
        if (normalized.length === 0) {
          this.$message.info('No valid URL IDs in selection.');
          return;
        }

        const { groups, allPolicies } = await fetchSuggestedPolicyGroups(normalized);
        this.allPoliciesForSuggestion = allPolicies;

        if (groups.length === 0) {
          this.$message.info('No common liveness scripts detected for suggested policy.');
          return;
        }

        this.suggestedPolicyGroups = groups;
        this.showSuggestedPolicyModal = true;
      } catch (error) {
        console.error('Suggested policy generation failed:', error);
        this.$showErrorMessage('Failed to generate suggested policy preview.');
      } finally {
        this.isSuggestingPolicy = false;
      }
    },
  },
};
